module.exports = __webpack_public_path__ + "img/img_lvshoucamp_beauty.5973b63f.png";